import { GalleryWrapper } from "components/product/galleryWrapper";

export function ProductDetailsCard({builderState}: {builderState: any}) {
    const product = builderState.state?.shopifyProduct
    if(!product) return <div>Please connect to a Shopify product to builder state</div>
    console.log('product', product)

    return (
        <div className="flex flex-col md:flex-row w-full h-full bg-white rounded-2xl border-none py-8">
            <div className="w-full px-8 flex flex-col justify-between h-full">
                {/* <h2 className="text-[28px] py-8 text-fp-dark-gray font-bold">
                    {product.title}
                </h2> */}
                <div className="">
                    <GalleryWrapper product={product}/>
                </div>
                {/* <div className="my-8 p-4 w-full text-base flex flex-col gap-y-4 items-center justify-center border-t border-[#e5e5ea]">
                    <ProductDiscount product={product as ShopifyProduct}/>                    
                    <ButtonGreen href="/shop" className={cn('text-nowrap h-10 md:h-[65px] w-full justify-center')}><div className="flex items-center gap-x-2"><ShoppingCartIcon/> Shop Packages</div></ButtonGreen>
                </div> */}
            </div>
        </div>
    )
}
